import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface LineChartOneProps {
  series: {
    name: string;
    data: number[];
  }[];
}

const LineChartOne: React.FC<LineChartOneProps> = ({ series }) => {
  const options: ApexOptions = {
    legend: {
      show: false,
      position: "top",
      horizontalAlign: "left",
    },
    colors: ["#465FFF", "#9CB9FF"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      type: "area",
      toolbar: {
        show: false,
      },
      parentHeightOffset: 0,
      height: '100%'
    },
    stroke: {
      curve: "smooth",
      width: [2, 2],
    },
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.55,
        opacityTo: 0,
      },
    },
    markers: {
      size: 0,
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 6,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          // Check if the series name contains "Ingreso" to determine if it's a currency value
          const seriesName = w.globals.seriesNames[seriesIndex] || '';
          if (seriesName.toLowerCase().includes('ingreso') || 
              seriesName.toLowerCase().includes('venta') || 
              seriesName.toLowerCase().includes('monto')) {
            // Format as currency if it's an income/sales series
            return `$${value.toLocaleString('en-US')} USD`;
          } else {
            // Keep the original formatter for non-currency values
            return value === 1 ? "1 reserva" : `${value} reservas`;
          }
        }
      }
    },
    xaxis: {
      type: "category",
      categories: [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
      ],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
          colors: ["#6B7280"],
        },
      },
      title: {
        text: "",
        style: {
          fontSize: "0px",
        },
      },
    },
  };

  return (
    <div className="h-full w-full">
      <Chart 
        options={options} 
        series={series} 
        type="area" 
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default LineChartOne;
